import * as $            from 'jquery';
import { onClick }       from 'Core/Events';
import { Notifications } from 'Core/Notifications';
import { FavouritesAPI } from 'Core/FavouritesAPI';

export class Favourites {

    private static Selector = {
        BUTTONS:   {
            ADD:    '.js_favorites_add',
            REMOVE: '.js_favorite_remove',
            CLEAR:  '#ClearFavorites',
        },
        COUNT:     '.js_fav_count',
        CONTAINER: '.js_product_container',
        ICON:      '.js_nav-icon-fav',
    };

    private static FAVOURITES_COUNT_LIMIT: number = 12;

    private static fav_page: boolean = $('body').find('#favouritesPage').length > 0 ? true : false;

    @onClick(Favourites.Selector.BUTTONS.ADD, Favourites.addToFavoritesHandler)
    @onClick(Favourites.Selector.BUTTONS.REMOVE, Favourites.removeFromFavoritesHandler)
    @onClick(Favourites.Selector.BUTTONS.CLEAR, Favourites.clearFavoritesHandler)

    private static checkIfAddedProductGoesBeyondCountLimit(): boolean {
        // Use first visible element since there may be multiple (mobile/desktop headers)
        const $el = $(Favourites.Selector.COUNT).filter(':visible').first();
        const count = $el.length ? parseInt($el.text()) || 0 : parseInt($(Favourites.Selector.COUNT).first().text()) || 0;
        return count + 1 > Favourites.FAVOURITES_COUNT_LIMIT;
    }

    private static updateCount(count: number): boolean {
        let active: boolean = count > 0;
        $(Favourites.Selector.COUNT)
            .toggle(active)
            .text(count);

        return active;
    }

    private static addToFavoritesHandler(this: HTMLElement, event: JQuery.Event) {
        const $this = $(this);
        const id    = $this.data("add-to-favorite-url");
        const itGoesBeyondCountLimit: boolean = Favourites.checkIfAddedProductGoesBeyondCountLimit();

        if (itGoesBeyondCountLimit) {
            Notifications.add('Osiągnięto limit produktów dodanych do ulubionych', "warning");
        } else {
            FavouritesAPI.add(id).done(res => {
                Favourites.updateCount(res.value);
                Favourites.favouriteClassChanger($this, id, 'add');
                Notifications.add(res.msg, res.result ? "success" : "warning", { lifespan: 3000 });
            });
        }

    }

    private static removeFromFavoritesHandler(this: HTMLElement, event: JQuery.Event) {
        const $this = $(this);
        const address    = $this.data("delete-from-favorite-url");
        const id = $this.data("product-id");

        FavouritesAPI.remove(address).done(res => {
            if (res.result) {
                $this.tooltip('hide');
                $this.closest(Favourites.Selector.CONTAINER).fadeOut(300, () => $this.remove());
                const moreThanOne = Favourites.updateCount(res.value);
                if (!moreThanOne) {
                    Favourites.noFavoriteHandler();
                }
                if(Favourites.fav_page == false) { //if page is other than favourite page (prod page, list etc)
                    Favourites.favouriteClassChanger($this, id, 'delete')
                }
                $("#product_tile_"+id).remove();
            }
            Notifications.add(res.msg, res.result ? "error" : "warning", {
                lifespan: 3000
            });
        });
    }

    private static favouriteClassChanger(target, id, action: string) {

        target.find('svg').remove();
        target.find('i').remove();
        target.find('img').remove();
        const iconVariant = target.attr('data-fav-icon');
        let text: string;
        if(action == 'add') {
            target
                .removeClass('js_favorites_add')
                .addClass('js_favorite_remove')
                .prepend(iconVariant === 'legacy'
                    ? '<i class="fas fa-heart f-20"></i>'
                    : '<img src="/public/build/assets/images/favs-filled.svg" alt="Usuń z ulubionych" class="product--fav-icon">');
            text = 'Usuń z ulubionych';

        } else {
            target
                .removeClass('js_favorite_remove')
                .addClass('js_favorites_add')
                .prepend(iconVariant === 'legacy'
                    ? '<i class="far fa-heart f-20"></i>'
                    : '<img src="/public/build/assets/images/favs.svg" alt="Dodaj do ulubionych" class="product--fav-icon">');
            text = 'Dodaj do ulubionych';
        }
        $(target).attr('data-original-title', text);
    }

    private static noFavoriteHandler() {
        $("#emptyFavourites").removeClass('d-none').show(250).text('Produkty zostały usunięte');
        $(Favourites.Selector.BUTTONS.CLEAR).hide(250);
        $("#favouritesPage").hide(250);
    }

    private static clearFavoritesHandler(this: HTMLElement, event: JQuery.Event) {
        const url  = window.location.toString();
        const lang = url.split('/')[3]; // It returns language shortcuts like 'pl' or 'en'

        FavouritesAPI.clear(lang).done(() => {
            Favourites.noFavoriteHandler();
            Favourites.updateCount(0);
        });
    }

}
import * as $            from 'jquery';
import { onClick }       from 'Core/Events';
import { Notifications } from 'Core/Notifications';
import { FavouritesAPI } from 'Core/FavouritesAPI';

export class Favourites {

    private static Selector = {
        BUTTONS:   {
            ADD:    '.js_favorites_add',
            REMOVE: '.js_favorite_remove',
            CLEAR:  '#ClearFavorites',
        },
        COUNT:     '.js_fav_count',
        CONTAINER: '.js_product_container',
        ICON:      '.js_nav-icon-fav',
    };

    private static FAVOURITES_COUNT_LIMIT: number = 12;

    private static fav_page: boolean = $('body').find('#favouritesPage').length > 0 ? true : false;

    @onClick(Favourites.Selector.BUTTONS.ADD, Favourites.addToFavoritesHandler)
    @onClick(Favourites.Selector.BUTTONS.REMOVE, Favourites.removeFromFavoritesHandler)
    @onClick(Favourites.Selector.BUTTONS.CLEAR, Favourites.clearFavoritesHandler)

    private static checkIfAddedProductGoesBeyondCountLimit(): boolean {
        // Use first visible element since there may be multiple (mobile/desktop headers)
        const $el = $(Favourites.Selector.COUNT).filter(':visible').first();
        const count = $el.length ? parseInt($el.text()) || 0 : parseInt($(Favourites.Selector.COUNT).first().text()) || 0;
        return count + 1 > Favourites.FAVOURITES_COUNT_LIMIT;
    }

    private static updateCount(count: number): boolean {
        let active: boolean = count > 0;
        $(Favourites.Selector.COUNT)
            .toggle(active)
            .text(count);

        return active;
    }

    private static addToFavoritesHandler(this: HTMLElement, event: JQuery.Event) {
        const $this = $(this);
        const id    = $this.data("add-to-favorite-url");
        const itGoesBeyondCountLimit: boolean = Favourites.checkIfAddedProductGoesBeyondCountLimit();

        if (itGoesBeyondCountLimit) {
            Notifications.add('Osiągnięto limit produktów dodanych do ulubionych', "warning");
        } else {
            FavouritesAPI.add(id).done(res => {
                Favourites.updateCount(res.value);
                Favourites.favouriteClassChanger($this, id, 'add');
                Notifications.add(res.msg, res.result ? "success" : "warning", { lifespan: 3000 });
            });
        }

    }

    private static removeFromFavoritesHandler(this: HTMLElement, event: JQuery.Event) {
        const $this = $(this);
        const address    = $this.data("delete-from-favorite-url");
        const id = $this.data("product-id");

        FavouritesAPI.remove(address).done(res => {
            if (res.result) {
                $this.tooltip('hide');
                $this.closest(Favourites.Selector.CONTAINER).fadeOut(300, () => $this.remove());
                const moreThanOne = Favourites.updateCount(res.value);
                if (!moreThanOne) {
                    Favourites.noFavoriteHandler();
                }
                if(Favourites.fav_page == false) { //if page is other than favourite page (prod page, list etc)
                    Favourites.favouriteClassChanger($this, id, 'delete')
                }
                $("#product_tile_"+id).remove();
            }
            Notifications.add(res.msg, res.result ? "error" : "warning", {
                lifespan: 3000
            });
        });
    }

    private static favouriteClassChanger(target, id, action: string) {

        target.find('svg').remove();
        target.find('i').remove();
        target.find('img').remove();
        const iconVariant = target.attr('data-fav-icon');
        let text: string;
        if(action == 'add') {
            target
                .removeClass('js_favorites_add')
                .addClass('js_favorite_remove')
                .prepend(iconVariant === 'legacy'
                    ? '<i class="fas fa-heart f-20"></i>'
                    : '<img src="/public/build/assets/images/favs-filled.svg" alt="Usuń z ulubionych" class="product--fav-icon">');
            text = 'Usuń z ulubionych';

        } else {
            target
                .removeClass('js_favorite_remove')
                .addClass('js_favorites_add')
                .prepend(iconVariant === 'legacy'
                    ? '<i class="far fa-heart f-20"></i>'
                    : '<img src="/public/build/assets/images/favs.svg" alt="Dodaj do ulubionych" class="product--fav-icon">');
            text = 'Dodaj do ulubionych';
        }
        $(target).attr('data-original-title', text);
    }

    private static noFavoriteHandler() {
        $("#emptyFavourites").removeClass('d-none').show(250).text('Produkty zostały usunięte');
        $(Favourites.Selector.BUTTONS.CLEAR).hide(250);
        $("#favouritesPage").hide(250);
    }

    private static clearFavoritesHandler(this: HTMLElement, event: JQuery.Event) {
        const url  = window.location.toString();
        const lang = url.split('/')[3]; // It returns language shortcuts like 'pl' or 'en'

        FavouritesAPI.clear(lang).done(() => {
            Favourites.noFavoriteHandler();
            Favourites.updateCount(0);
        });
    }

}
